<template>
  <section id="search">
    <div class="demo">
      <h5>Simple search bar</h5>
      <div class="input-group w-50">
          <input type="search" placeholder="keyword" aria-label="search box" class="form-control">
          <div class="input-group-append">
              <button type="button" id="button-addon2" class="btn btn-primary" aria-label="Search"><i class="gel-icon-search" aria-hidden="true"></i></button>
          </div>
      </div>
      <br>
      <h5>Tagged search bar</h5>
      <form class="input-group tags-input">
        <ul class="tags form-control">
          <li>Tag = employeereferral
            <button type="button" aria-label="remove">
              <i class="gel-icon-close"></i>
            </button>
          </li>
          <li class="search-field">
            <label for="tags-input-value" class="sr-only">search</label><input id="tags-input-value" type="text" autocomplete="off"/></li>
        </ul>
        <div class="input-group-append">
          <button class="btn btn-primary" type="button" aria-label="Search">
            <i class="gel-icon-search gel-icon-lg"></i>
          </button>
        </div>
      </form>
    </div>
        <section class="md" v-html="mdfile"></section>  
  </section> 
</template>

<script>
import mdfile from "@/docs/components/search.md";
export default {
  name: "search",
  beforeCreate: function () {
    this.$emit("update-title", this.$root.yamlData.components.search.name);
    this.$emit("update-tagline", this.$root.yamlData.components.search.description);
  },
  data() {
    return {
      mdfile
    };
  }
};
</script>
